module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/icon_number_04_yellow-b1d5716deda8f9889e4ba4a70ea02899.svg";